let html = `<div class="extensions__item extensions__item--theme selector layer--visible layer--render">
    <div class="extensions__item-imagebox">
        <img class="extensions__item-image" />
    </div>
    <div class="extensions__item-body">
        <div class="extensions__item-name"></div>
    </div>
</div>`

export default html